import { render, staticRenderFns } from "./VTabLink.vue?vue&type=template&id=ec91b8cc&"
import script from "./VTabLink.vue?vue&type=script&lang=js&"
export * from "./VTabLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports